export default status => {
  if (status === 'PENDING') {
    return '#e2e2e2';
  } if (status === 'REGISTRATION_PENDING') {
    return '#e2e2e2';
  } if (status === 'ACCOUNT_CREATED') {
    return '#ffe0b1';
  } if (status === 'ACCOUNT_VERIFIED') {
    return '#ececff';
  } if (status === 'ACCOUNT_LIVE') {
    return '#ffe0b1';
  } if (status === 'TO_ACTIVATE') {
    return '#ffe0b1';
  } if (status === 'ACTIVE') {
    return '#ffe0b1';
  } if (status === 'CLOSED') {
    return '#e2e2e2';
  } return '#e2e2e2';
};
